import { useEffect } from "react";

const ADMIN_HEAD_TAGS: Array<Record<string, string>> = [
	{ tag: "link", rel: "manifest", href: "/admin.webmanifest" },
	{ tag: "link", rel: "apple-touch-icon", href: "/admin-apple-touch-icon.png" },
	{ tag: "meta", name: "apple-mobile-web-app-title", content: "Gestione negozio" },
	{ tag: "meta", name: "apple-mobile-web-app-capable", content: "yes" },
	{ tag: "meta", name: "mobile-web-app-capable", content: "yes" },
];

/**
 * Nell'area /admin aggiunge al <head> manifest e icona dedicati, così
 * "Aggiungi a schermata Home" crea l'icona "Gestione negozio" che apre
 * direttamente il pannello. Come app installata la sessione Supabase non
 * subisce la pulizia dello storage di Safari dopo 7 giorni senza visite,
 * quindi password + codice 2FA vanno inseriti di rado.
 */
export function useAdminHomeScreen(isAdminArea: boolean) {
	useEffect(() => {
		if (!isAdminArea) return;

		const elements = ADMIN_HEAD_TAGS.map(({ tag, ...attrs }) => {
			const el = document.createElement(tag);
			for (const [key, value] of Object.entries(attrs)) el.setAttribute(key, value);
			document.head.appendChild(el);
			return el;
		});

		return () => elements.forEach((el) => el.remove());
	}, [isAdminArea]);
}
